<template>
  <div>
    <SystemBar ref="system-bar" />
    <StreamingNotification v-if="streamingPlayer.isActive" />
    <div class="connection-alert w-100 active">
      <div
        class="alert alert-light shadow m-5 text-center"
        role="alert"
      >
        <div
          class="text-primary mt-3 m-auto"
          style="height: 23px; width: 23px; font-size: 8px"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-6 h-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M3 8.25V18a2.25 2.25 0 002.25 2.25h13.5A2.25 2.25 0 0021 18V8.25m-18 0V6a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 6v2.25m-18 0h18M5.25 6h.008v.008H5.25V6zM7.5 6h.008v.008H7.5V6zm2.25 0h.008v.008H9.75V6z"
            />
          </svg>
        </div>
        <p class="mt-2 text-primary">
          {{ $t('errorsPlatforms.tabsDouble.title') }}
        </p>
        <hr class="divide" />
        <p class="text-muted">
          <small>{{ $t('errorsPlatforms.tabsDouble.body') }}</small>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    SystemBar: () => import(/* webpackPrefetch: true */ '@/components/SystemBar.vue'),
    StreamingNotification: () => import(/* webpackPrefetch: true */ '@/views/room/components/Notification.vue')
  },
  computed: {
    streamingPlayer () {
      return this.$organization.streamingPlayer()
    }
  }
})
export default class Index extends Vue {
  mounted () {
    const storage = this.$store.state.storage
    const user = storage?.room?.cammer?.user

    if (user) {
      this.$widget.setSessionCammerVar(user)
    }

    this.$widget.setBuyOrderSessionId()
  }
}
</script>

<style>
.connection-alert {
  background: #ffffff;
  z-index: 11;
  visibility: hidden;
  transition: all 0.2s;
  height: 94vh;
}

.connection-alert .alert {
  width: 80vw;
}

.connection-alert hr {
  background: #2a2b2b50;
}

.connection-alert.active {
  visibility: visible;
  display: flex;
  justify-content: center;
  align-items: center;
}

.m-auto {
  margin: auto;
}

.divide {
  background: #2a2b2b50;
  border: 1px solid #2a2b2b50;
}

.text-primary {
  color: #347bf8;
}
</style>
